import styled from "styled-components";

/** Botão/insignia "Alerta Criado" — abre o alerta vinculado */
export const AlertCreatedButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  font-family: inherit;
  letter-spacing: 0.02em;
  cursor: pointer;
  color: var(--text-on-accent, #fff);
  background: var(--accent, #6b8f71);
  border: 1px solid var(--accent, #6b8f71);
  box-shadow: 0 1px 2px color-mix(in srgb, var(--accent) 35%, transparent);
  text-decoration: none;
  white-space: nowrap;
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease,
    opacity 0.15s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    filter: brightness(1.05);
    box-shadow: 0 4px 12px color-mix(in srgb, var(--accent) 40%, transparent);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.65;
    cursor: wait;
  }
`;

export const ResolutionStatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
  color: ${({ $status }) =>
    $status === "rejected"
      ? "var(--danger)"
      : $status === "created"
        ? "var(--accent)"
        : "var(--warning)"};
  background: ${({ $status }) =>
    $status === "rejected"
      ? "color-mix(in srgb, var(--danger) 18%, transparent)"
      : $status === "created"
        ? "var(--accent-soft)"
        : "color-mix(in srgb, var(--warning) 18%, transparent)"};
  border: 1px solid
    ${({ $status }) =>
      $status === "rejected"
        ? "color-mix(in srgb, var(--danger) 35%, transparent)"
        : $status === "created"
          ? "var(--accent)"
          : "color-mix(in srgb, var(--warning) 40%, transparent)"};
`;
